var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import AntdSlider from 'antd/es/slider';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
const Slider = forwardRef((_a, ref) => {
    var { className, colorRange, prefixCls: customizePrefixCls, vertical = false, min = 0, max = 100, size = 'default' } = _a, rest = __rest(_a, ["className", "colorRange", "prefixCls", "vertical", "min", "max", "size"]);
    const innerRef = useRef(null);
    const [railWidth, setRailWidth] = useState(0);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('slider', customizePrefixCls);
    useEffect(() => {
        var _a;
        const sliderRail = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.ant-slider-rail');
        setRailWidth(sliderRail === null || sliderRail === void 0 ? void 0 : sliderRail.offsetWidth);
        let resizeWaiter = false;
        window.addEventListener('resize', () => {
            if (!resizeWaiter) {
                resizeWaiter = true;
                setTimeout(() => {
                    setRailWidth(sliderRail === null || sliderRail === void 0 ? void 0 : sliderRail.offsetWidth);
                    resizeWaiter = false;
                }, 300);
            }
        });
    }, []);
    useEffect(() => {
        var _a, _b;
        if (!(colorRange === null || colorRange === void 0 ? void 0 : colorRange.length))
            return;
        const sliderTrack = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.ant-slider-track');
        sliderTrack.innerHTML = '';
        const defaultColor = window.getComputedStyle(sliderTrack, null).getPropertyValue('background-color');
        let left = 0;
        const newColors = colorRange.find(item => (item === null || item === void 0 ? void 0 : item.value) === max)
            ? [...colorRange]
            : [...colorRange, { value: max, color: defaultColor }];
        (_b = newColors === null || newColors === void 0 ? void 0 : newColors.sort((a, b) => (a === null || a === void 0 ? void 0 : a.value) - (b === null || b === void 0 ? void 0 : b.value))) === null || _b === void 0 ? void 0 : _b.forEach((item, index) => {
            if ((item === null || item === void 0 ? void 0 : item.value) > min && (item === null || item === void 0 ? void 0 : item.value) <= max) {
                const node = document.createElement('div');
                node.className = `${prefixCls}-track`;
                const width = (((item === null || item === void 0 ? void 0 : item.value) - min) / (max - min)) * railWidth - left;
                node.style.width = `${width + (index < newColors.length - 1 ? 4 : 0)}px`;
                node.style.left = `${left}px`;
                node.style.backgroundColor = item === null || item === void 0 ? void 0 : item.color;
                sliderTrack === null || sliderTrack === void 0 ? void 0 : sliderTrack.appendChild(node);
                left += width;
            }
        });
    }, [colorRange, max, min, prefixCls, railWidth, ref]);
    return (React.createElement("div", { className: classnames(`${prefixCls}-wrap`, { [`${prefixCls}-vertical`]: vertical }), ref: innerRef },
        React.createElement(AntdSlider, Object.assign({}, rest, { ref: ref, min: min, max: max, vertical: vertical, className: classnames(prefixCls, { [`${prefixCls}-${size}`]: size }, className) }))));
});
export default Slider;
